export default "__VITE_ASSET___HaQw2y2__"